const intialState = {
  tableSearch: {
    searchCategory: "",
    searchText: "",
  },
  dateFilter: { startDate: "", endDate: "" },
  statisticsFilter: "All",
  serviceType: "all",
  service: "all",
  organisationID: "all",
  selectedColumns: [],
};
const MIReducer = (state = intialState, action) => {
  switch (action.type) {
    case "setFilterValues":
      return { ...state, ...action.payload };
    case "clearAllFilters":
      return { ...intialState };
    default:
      return state;
  }
};
export default MIReducer;
